import AbstractChatMessage from './AbstractChatMessage'
import { MessageTypes } from '@/constants/chat/MessageTypes'
import { Roles } from '@/constants/user/roles'

export default class GigRefundedChatMessage extends AbstractChatMessage {
  type = MessageTypes.GIG_REFUNDED
  body: {
    reason: string
  }

  constructor(data: LX.GigRefundedChatMessage) {
    super(data)
    this.body = data.body
  }

  static fromServer(data: LX.GigRefundedChatMessage) {
    return new GigRefundedChatMessage(data)
  }

  getShortMessage(userId: string, role: Roles) {
    const isOwn = this.sender === `${userId}:${role}`
    return isOwn ? 'You have requested a refund' : 'Customer requested a refund'
  }
}
